import React, { useState } from 'react';
import { AccordionDetails, AccordionSummary, Accordion, Box, Typography, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { Item } from '../../types';
import { styles } from './ItemsNames.styles';

const intl = {
  name: 'Name',
  accordionTitle: 'Show Items'
};

type ItemsNamesProps = {
  items: Item[];
  accordionTitle?: string;
  alwaysShowAccordion?: boolean;
  onDelete?: (item: Item) => void;
};

export const ItemsNames = ({
  items,
  accordionTitle = intl.accordionTitle,
  alwaysShowAccordion = false,
  onDelete
}: ItemsNamesProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const canDelete = typeof onDelete === 'function';

  return items.length === 1 && !alwaysShowAccordion ? (
    <Box data-test="itemsNameContainer">
      <Typography sx={styles.label} component="label" htmlFor="itemsName">
        {intl.name}
      </Typography>
      <Typography id="itemsName" noWrap={true} component="div">
        {items[0].title}
      </Typography>
    </Box>
  ) : (
    <Accordion
      sx={styles.container}
      expanded={isExpanded}
      onChange={() => {
        setIsExpanded(!isExpanded);
      }}
      data-test="itemsNamesAccordion"
    >
      <AccordionSummary
        id="itemsNamesAccordionHeader"
        sx={styles.summary}
        expandIcon={<ArrowForwardIos sx={styles.arrowIcon} />}
        aria-controls="itemsNamesAccordionContent"
      >
        <Typography variant="h4" component="h2">
          {accordionTitle}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.details} id="itemsNamesAccordionContent">
        {items.map((item) => (
          <Chip
            key={item.id}
            label={item.title}
            deleteIcon={canDelete ? <CloseIcon aria-label="remove" /> : undefined}
            onDelete={
              canDelete
                ? () => {
                    onDelete(item);
                  }
                : undefined
            }
            size="small"
            variant="outlined"
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
